export const Buttons = (props) => {
  const { summaryActive } = props.context

  const checkDisplayCondition = () => {
    return !(
      props.display_condition &&
      ((!summaryActive && props.display_condition === "summary-active") ||
        (summaryActive && props.display_condition === "summary-inactive"))
    )
  }

  return (
    checkDisplayCondition() && (
      <div class={`buttons ${props.class || ""}`}>
        {props.buttons.map((buttonProps) => {
          return <Button context={props.context} {...buttonProps} />
        })}
      </div>
    )
  )
}

export const Button = (props) => {
  const { requirementsMet, inFormValues, onSubmit, setModalData, showStep } =
    props.context

  const disabled = () => {
    if (props.type === "next") {
      return !requirementsMet()
    }
    if (props.type === "submit" && props.function === "sendAnonymously") {
      return [{ name: "reporter_gender" }, { name: "reporter_role" }].some(
        (c) => inFormValues(c),
      )
    }
    if (typeof props.disabled !== "undefined") {
      return props.disabled
    }
    return false
  }

  const isExternalUrl = (url) => {
    if (!url) return false

    try {
      // Relative URLs (starts with / or # or ?) are internal
      if (url.startsWith("/") || url.startsWith("#") || url.startsWith("?")) {
        return false
      }

      // Check if URL has different hostname
      if (url.startsWith("http://") || url.startsWith("https://")) {
        const urlObj = new URL(url)
        return urlObj.hostname !== window.location.hostname
      }

      // Other protocols (mailto:, tel:, etc.) are considered external
      if (url.includes(":")) {
        return true
      }

      // Relative URLs without slash are internal
      return false
    } catch (_e) {
      return false
    }
  }

  const customFunctions = (e) => {
    e.preventDefault()

    if (props.onClick) props.onClick()
    else {
      switch (props.type) {
        case "submit":
          onSubmit()
          break
        case "link":
          document.location = props.href
          break
        case "external-link":
          window.open(props.href, "_blank")
          break
        case "menu-page":
          window.dispatchEvent(
            new CustomEvent("meldetool_open-menu-page", {
              detail: props.menu_page,
            }),
          )
          break
        case "close":
          // modal specific
          setModalData({})
          break
        default:
          // next step
          if (props.id) showStep(0, props.id)
          else showStep(1)
      }
    }
  }

  const buttonClass =
    `button ${props.class || ""} ${isExternalUrl(props.href) ? "external" : ""}`.trim()

  return (
    <button
      class={buttonClass}
      type={props.type}
      onClick={customFunctions}
      disabled={disabled()}
    >
      {props.label}
      {disabled()
        ? // biome-ignore lint/a11y: just a visual helper element, no need to be pedantic
          <div
            class="requirements-help"
            onClick={props.form?.showHelp}
            onKeyUp={props.form?.showHelp}
          >
            <div>{gettext("Weitere Angaben erforderlich")}</div>
          </div>
        : null}
    </button>
  )
}
